import * as React from 'react';
import { useState } from 'react';

import { Button } from '@shared/components/bootstrap';

import { Permission } from '@admin/components/helpers/permission';
import { BILLING } from '@admin/libraries/access_control_catalog.generated';

import { Dialog } from './dialog';

export const Action: React.FC<{
  refundable: {
    id: string;
    receivable_id?: string;
    amount: number | string;
  };
}> = ({ refundable }) => {
  const [visible, setVisible] = useState(false);
  const onToggle = () => setVisible(!visible);

  return (
    <Permission resource={BILLING.resource} action={BILLING.actions.update} denied={null}>
      {visible && <Dialog onClose={onToggle} refundable={refundable} />}
      <Button kind="primary" onClick={onToggle}>
        Refund
      </Button>
    </Permission>
  );
};
